import React from "react";
/* Der Überzug eines modalen Bildes: die verdunkelte Fläche über dem Inhalt und die
   Bühne darüber, die das Kind trägt. Die Platte selbst ist ein anderer Baustein —
   `Modal` nimmt jedes Kind: einen Dialog, eine Schublade, eine Karte.

   Er zeichnet und verhält sich nicht. Kein Fokusfang, kein Esc, kein Scroll-Lock:
   Das Schließen bleibt beim Aufrufer, der `onClose` mitgibt. */
export function Modal({ children, onClose, zIndex = 40, style = {} }) {
  return (
    <React.Fragment>
      <div onClick={onClose} style={{ position: "absolute", inset: 0, zIndex, background: "var(--bg-login-scrim)", backdropFilter: "var(--blur-scrim)", WebkitBackdropFilter: "var(--blur-scrim)" }} />
      <div style={{ position: "absolute", zIndex: zIndex + 1, top: "50%", left: "50%", transform: "translate(-50%,-50%)", ...style }}>
        {children}
      </div>
    </React.Fragment>
  );
}
